import React from 'react';
import data from '../../data/db.json';

const InvestAffordable = ({ pageName }) => {
    const { InvestAffordable, list } = data[pageName]; 
    
    return (
        <>
            <section className="bg-grey my-5">
                <div className="container  py-4 blackColor" >
                    {InvestAffordable?.map((item, key) => {
                        return (
                            <>
                                <h4 style={{fontWeight:800}}>{item?.heading}</h4>
                                <p className="my-3">
                                    {item?.desc}
                                </p>
                            </>
                        )
                    })}
                </div>
            </section>
        </>
    );
};

export default InvestAffordable;
